import { IonContent } from '@ionic/react';
import React from 'react';

import { GIRLS_CATEGORY, WOMEN_CATEGORY } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { useLayoutFormSelections } from '../../../OwnAISecond/hooks/useLayoutFormSelections';
import { OwnAiTitle } from '../../components/Title';

import { ScreenAboutLookStyles } from './AboutLook.styles';

export const ScreenAboutLook: React.FC = () => {
  const { ageGeneration, bodyShape, hairColor, age } =
    useLayoutFormSelections();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutLook',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    const categoriesToPin = age === '50_plus' ? WOMEN_CATEGORY : GIRLS_CATEGORY;

    userService.createOrUpdate({
      categories: [categoriesToPin],
      onboarding_data: {
        first_categories: categoriesToPin,
      },
    });
    wizard.nextStep();
  };

  const getBgImage = () => {
    const needToPersonalize = webCampaign.getKey() === 'g34bjedPA';

    if (needToPersonalize) {
      return `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-second/${ageGeneration}/${bodyShape}/${hairColor}/ai_say.jpg`;
    }

    return 'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/bg-about-look.png';
  };

  return (
    <ScreenAboutLookStyles bgImage={<img src={getBgImage()} alt="Chat Vibe" />}>
      <IonContent>
        <OwnAiTitle className="local-title">
          Wow, That Look? Impressive!
        </OwnAiTitle>
        <OnboardingSubtitle>
          You’ve nailed the appearance—seriously, great choice! Now, let’s dive
          into the personality. Ready to make them truly one of a kind?
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ScreenAboutLookStyles>
  );
};
